import StickyHome from "./home/sticky-home.js";
import sectionEventUtils from "../scripts/home/sectionLoadUtils";

Logger.debug('script home loaded');

/** init **************************************************************************************************************/
const app = Voonto.getInstance();
const nibara = window.nibara;
const feature = nibara.feature;

const libPath = app.lookup('vocento.config.nibara').libPath;
if (libPath === undefined) {
  throw 'nibara libPath config is empty';
}


/** sticky voc home init **********************************************************************************************/
if (feature.stickyAds && (Voonto.is.desktop() || Voonto.is.tablet())) {
  Logger.debug("feature stickyAds active");
  const stickyHome = new StickyHome();
  stickyHome.iniciar();
  Voonto.$('[data-section="main"]').find('[data-sticky-home]').on('vam:slotrendered', function () {
    Logger.info('stickyHome over elemente id: ' + Voonto.$(this).attr('id'));
    stickyHome.addElement(this);
    stickyHome.recalcularTodo();
  });
}

// jquery Stick feature
if (feature.jqStickyAds && (Voonto.is.desktop() || Voonto.is.tablet())) {
  Logger.debug("feature jqStickyAds active");
  app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function() {
    Voonto.$('[data-section="main"]').find('[data-sticky-home]').on('vam:slotrendered', function () {
      Logger.info('jqStickyHome over elemente id: ' + Voonto.$(this).attr('id'));
      Voonto.$(this).stick_in_parent({offset_top: 45});
    });
  });
}

// change section in sticky header
sectionEventUtils.onClickMainHome(Voonto.$('span.cabecera-sticky span.contenido-cabecera'));
sectionEventUtils.onClickMainHome(Voonto.$('.cabecera'));

/** default change url */
sectionEventUtils.changeSectionName(Voonto.$('[data-section="main"]'));

// vuelta atras y cambio de url
if (feature.homeBacktrace) {
  Logger.debug("feature homeBacktrace active");
  /** force auto ever */
  history.scrollRestoration = 'auto';

  /** create history with main if not exist */
  if (history.state === null) {
    history.replaceState({section: 'main'}, 'main', '/' + window.location.search + window.location.hash);
  }

  nibara.isBack = sectionEventUtils.isBackView() === true;

  /** search link event to find section owner and change lastview in session  *******/
  //sectionEventUtils.onClickSetHistoryHome(Voonto.$('main'));
  let $mainChildren = Voonto.$('main').children();
  sectionEventUtils.onClickTerrazaHome($mainChildren.not('[data-section]'));
  sectionEventUtils.onClickSetHistoryHome($mainChildren.filter('main[data-section]'));
  sectionEventUtils.onClickSetHistoryHome(Voonto.$('nav.navegacion'));
  sectionEventUtils.onClickSetHistoryHome(Voonto.$('span.cabecera-sticky.visible span.contenido-cabecera span.titulo-seccion'));
  sectionEventUtils.onClickSetHistoryHome(Voonto.$('span.nombre-seccion'));

  /** go to section view */
  if (sectionEventUtils.isBackView() === true && history.state.lastSectionView !== 'main') {
    nibara.lastSectionView = history.state.lastSectionView;
    let $lastSectionViewElm = Voonto.$('[data-section=' + nibara.lastSectionView + ']');
    if ($lastSectionViewElm && typeof $lastSectionViewElm.offset() === "object") {
      /** location temporally disabled */
      history.scrollRestoration = 'manual';
      Voonto.$('.oreja').removeClass('fija');
      nibara.sectionLocationWatch = setInterval(function () {
        window.scrollTo(0, $lastSectionViewElm.offset().top + 5);
      }, 10);
    }
  }
}

/** scroll  event
 * sticky skies
 * cmv_wallpaper
 * @type {boolean}
 */
if (Voonto.is.desktop()) {
  let stickySkyLocked = false;
  let $window = Voonto.$(window);
  let $mainSection = Voonto.$('[data-section="main"]');
  Voonto.$(window).on("scroll", nibara.nTools.throttle(50, function () {
    let top = $window.scrollTop();
    let mainHeigh = $mainSection.height() + $mainSection.offset().top - $window.height() + 100;
    if (top > mainHeigh && stickySkyLocked === false) {
      stickySkyLocked = true;
      Voonto.$('.oreja').removeClass('fija').css('position', 'absolute').css('top', mainHeigh);
      Voonto.$('.cmv_wallpaper').hide();
    }
    if (top < mainHeigh && stickySkyLocked === true) {
      stickySkyLocked = false;
      Voonto.$('.oreja').addClass('fija').removeAttr('style');
      Voonto.$('.cmv_wallpaper').show();
    }
  }));
}


/**
 * Scroll direction
 * Set tracking var scroll direction
 * @type {boolean}
 */
let
  lastScrollPosition = 0
;
window.vocento.tracking.comscore.scrollDireccion = '';
Voonto.$(window).on("scroll", function () {
  let newScrollPosition = window.scrollY;
  if (newScrollPosition < lastScrollPosition) {
    window.vocento.tracking.comscore.scrollDireccion = 'up';
  } else {
    window.vocento.tracking.comscore.scrollDireccion = 'down';
  }
  lastScrollPosition = newScrollPosition;
});



// WEBPACK FOOTER //
// ./src/scripts/home-script.js